/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type { GetReportsDashboardOverviewQueryResponse } from '../types/GetReportsDashboardOverview'

function getGetReportsDashboardOverviewUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/reports/dashboard/overview/` as const,
  }
  return res
}

/**
 * @description Flat set of metric cards for the reports dashboard header. Returns {} when the company has no deal-report rows; total_pipeline_value is present only when the enable_total_pipeline_value feature flag is on for the requesting user's company.
 * @summary Reports dashboard overview metric cards
 * {@link /api/v1/reports/dashboard/overview/}
 */
export async function getReportsDashboardOverview(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetReportsDashboardOverviewQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetReportsDashboardOverviewUrl().url.toString(),
    ...requestConfig,
  })
  return res.data
}
